export default {
  rootGrid: {
    flexGrow: 1,
    marginTop: 20,
    justifyContent: 'center',
  },
  title: {
    textAlign: 'center',
  },
  text: {
    textAlign: 'center',
  },
  appstoreButton: {},
  appstoreImage: {
    width: 160,
    height: 54,
  },
}
